import { API_BASE_URL } from '../config';

export const checkSubscriptionAndRedirect = async (
  navigate,
  onHasSubscription = () => {},
  onNoSubscription = () => navigate('/checkout?redirect=subscriptionCheck')
) => {
  const token = localStorage.getItem('token');
  if (!token) {
    navigate('/login');
    return;
  }

  try {
    const response = await fetch(`${API_BASE_URL}/api/active-subscription`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error('Failed to fetch subscription status');
    }

    const data = await response.json();
    if (data.hasActiveSubscription) {
      onHasSubscription();
    } else {
      onNoSubscription();
    }
  } catch (error) {
    console.error('Error checking subscription:', error);
    onNoSubscription();
  }
};